// @flow
import * as React from 'react'

import './TabBar.scss'

type Props = {
  onChange: (key: string) => void,
  tabs: string[],
  currentTab: string,
}

export default class TabBar extends React.Component<Props> {
  render = () => {
    return (
      <div className="TabBar">
        {this.props.tabs.map(tab => (
          <a onClick={() => this.props.onChange(tab)} key={tab} className="TabBar-link">
            <span
              className={`TabBar-linkText ${
                this.props.currentTab === tab ? 'TabBar-linkText--selected' : ''
              }`}
            >
              {tab}
            </span>
          </a>
        ))}
      </div>
    )
  }
}
